<template>
  <div class="winner-page" v-if="winner_image">
    <img class="winner-bg" :src="winner_image" alt="wheel" />

    <div class="payout-card">
      <div class="you-won-label">YOU WON</div>
      <div class="win-amount">${{win_dollar}}</div>
      <p class="payout-intro">{{need_payment ? 'Your Instagram and where to send it.' : 'Your Instagram so we can check the follow.'}}</p>

      <div v-if="!payout_sent">
        <label class="field-label" for="instagram">Your Instagram</label>
        <div class="pill-field">
          <span class="pill-prefix">@</span>
          <input
              type="text"
              id="instagram"
              v-model="instagram"
              name="instagram"
              placeholder="yourhandle"
              autocomplete="off"
              autocapitalize="off"
              autocorrect="off"
          />
        </div>

        <template v-if="need_payment">
          <div class="field-label">Send winning $ to</div>
          <div class="method-list">
            <button type="button" class="method-row" :class="{ on: method_edit === 'Venmo' }" @click="pick_method('Venmo')">Venmo</button>
            <button type="button" class="method-row" :class="{ on: method_edit === 'Cash App' }" @click="pick_method('Cash App')">Cash App</button>
          </div>
          <div class="pill-field" v-if="method_edit">
            <span class="pill-prefix">{{method_edit === 'Cash App' ? '$' : '@'}}</span>
            <input
                type="text"
                ref="payout_handle"
                v-model="handle_edit"
                :placeholder="method_edit === 'Cash App' ? 'cashtag or phone' : 'your-venmo'"
                autocomplete="off"
                autocapitalize="off"
                autocorrect="off"
            />
          </div>
        </template>

        <div class="payout-error" v-if="payout_error">{{payout_error}}</div>

        <button
            type="button"
            class="send-btn"
            @click="send_payout"
            :disabled="payout_sending">
          Send it
        </button>
      </div>

      <div v-else class="payout-done">
        <div class="got-it">Got it. {{sent_method}} {{sent_handle_display}}.</div>
        <p>We'll text {{phone}} when it's sent.</p>
        <p>Stay following @frootinsiders. We check before we pay.</p>
      </div>
    </div>
  </div>
  <div v-else>
    <!--    Empty-->
  </div>
</template>


<script>
import * as api from '@/api'

export default {
  name: 'WinnerPage',
  components: {
  },
  data() {
    return {
      instagram: '',
      method_edit: '',
      handle_edit: '',
      sent_method: '',
      sent_handle_display: '',
      payout_sent: false,
      payout_sending: false,
      payout_error: '',
    };
  },
  props: {
    winner_image: null,
    win_dollar: null,
    full_name: null,
    code: null,
    phone: null,
    payout_method: null,
    payout_handle: null,
  },
  computed: {
    need_payment() {
      return !((this.payout_handle || '').trim());
    },
  },
  mounted() {
    api.stageLog({code: this.code, stage: 50});
  },
  watch: {
    // signedIn: async function() {
    // },
  },
  methods: {
    pick_method(method) {
      this.method_edit = method;
      this.$nextTick(() => {
        if (this.$refs.payout_handle) {
          this.$refs.payout_handle.focus();
        }
      });
    },
    send_payout() {
      let ig = (this.instagram || '').trim().replace(/^@+/, '');
      let method = this.need_payment ? this.method_edit : this.payout_method;
      let handle = this.need_payment ? this.handle_edit : this.payout_handle;
      handle = (handle || '').trim().replace(/^@+/, '').replace(/^\$+/, '');

      if (ig.length < 2) {
        this.payout_error = 'Please enter your Instagram.';
        return;
      }
      if (this.need_payment && (!method || handle.length < 2)) {
        this.payout_error = 'Please choose Venmo or Cash App and enter the account.';
        return;
      }

      this.payout_error = '';
      this.payout_sending = true;
      this.sent_method = method;
      this.sent_handle_display = (method === 'Cash App' ? '$' : '@') + handle;

      api.submitPayout({
        code: this.code,
        instagram: ig,
        payout_method: method,
        payout_handle: handle,
        win_dollar: this.win_dollar,
      }).then(() => {
        this.payout_sent = true;
        this.payout_sending = false;
      }).catch(() => {
        this.payout_error = 'Could not send. Please try again.';
        this.payout_sending = false;
      });
    },
  }
}

</script>

<style scoped>
.winner-page {
  position: relative;
  width: 100%;
}
.winner-bg {
  display: block;
  width: 100%;
}
.payout-card {
  position: absolute;
  left: 4%;
  right: 4%;
  top: 42%;
  background: #fff;
  border-radius: 28px;
  padding: 28px 22px 24px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.18);
  color: #16303a;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.you-won-label {
  font-size: 11px;
  letter-spacing: 0.14em;
  color: #8aa0a8;
  font-weight: 600;
  margin-bottom: 4px;
}
.win-amount {
  font-size: 52px;
  line-height: 1;
  font-weight: 800;
  color: #12262e;
  letter-spacing: -0.03em;
  margin-bottom: 10px;
}
.payout-intro {
  margin: 0 0 22px;
  color: #6b7f86;
  font-size: 16px;
}
.field-label {
  display: block;
  font-size: 15px;
  font-weight: 700;
  color: #1a3038;
  margin: 0 0 8px;
}
.pill-field {
  display: flex;
  align-items: center;
  background: #f3f6f8;
  border: 2px solid transparent;
  border-radius: 16px;
  padding: 0 14px;
  min-height: 52px;
  margin-bottom: 18px;
}
.pill-field:focus-within {
  border-color: #7eb7c6;
  background: #fff;
}
.pill-prefix {
  color: #8aa0a8;
  font-size: 16px;
  margin-right: 6px;
  flex: 0 0 auto;
}
.pill-field input {
  flex: 1 1 auto;
  border: 0;
  background: transparent;
  outline: none;
  font-size: 16px;
  color: #1a3038;
  min-width: 0;
  width: 100%;
  padding: 12px 0;
}
.pill-field input::placeholder {
  color: #9aafb6;
}
.method-list {
  display: flex;
  border: 1px solid #e4eaed;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 10px;
  background: #f3f6f8;
}
.method-row {
  flex: 1 1 50%;
  display: block;
  width: 50%;
  text-align: center;
  border: 0;
  border-right: 1px solid #e4eaed;
  background: transparent;
  color: #1a3038;
  font-size: 15px;
  font-weight: 600;
  padding: 8px 6px;
  cursor: pointer;
}
.method-row:last-child {
  border-right: 0;
}
.method-row.on {
  background: #16343d;
  color: #fff;
}
.send-btn {
  display: block;
  width: 100%;
  margin-top: 6px;
  border: 0;
  border-radius: 16px;
  background: #16343d;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  padding: 16px 12px;
  cursor: pointer;
}
.send-btn:disabled {
  opacity: 0.6;
  cursor: default;
}
.payout-error {
  color: #c0392b;
  font-size: 14px;
  margin: -6px 0 12px;
}
.payout-done .got-it {
  background: #e8f8ee;
  color: #1b6b3a;
  border-radius: 12px;
  padding: 12px 14px;
  font-weight: 600;
  margin-bottom: 14px;
}
.payout-done p {
  margin: 0 0 10px;
  color: #3d5560;
  font-size: 15px;
  line-height: 1.4;
}
</style>
